import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";

import { notBlank } from "../../util/ext";
import Grid from "@material-ui/core/Grid";
import { useHistory, useLocation, useParams } from "react-router-dom";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Header from "../../creator-application/common/Header";
import {
  useContentProviderEndpoints,
  useContentProviders,
  useMetadataDiscoveryEvent,
} from "./processingDiscoveryServices";
import MeatadataFileDiscoveryEventCard from "./MeatadataFileDiscoveryEventCard";
import MetadataFileDiscoveryErrorsCard from "./MetadataFileDiscoveryErrorsCard";
import MetadataFileDiscoveryMediaCard from "./MetadataFileDiscoveryMediaCard";

const useStyles = makeStyles(theme => ({
  root: {
    border: "3px white solid",
    backgroundColor: "white",
    borderRadius: "20px",
  },

  panel: {
    backgroundColor: "white",
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    maxHeight: "calc(100vh - 300px)",
    minHeight: "calc(100vh - 300px)",
    overflowY: "auto",
  },
}));

const MetadataFileDiscoveryDetailView = () => {
  const classes = useStyles();
  const history = useHistory();
  const { state = {} } = useLocation();
  const { jobId } = useParams();
  const [metadataFileDiscovery, setMetadataFileDiscovery] = useState(null);

  const eventResponse = useMetadataDiscoveryEvent(jobId);
  useEffect(() => {
    if (eventResponse.isSuccess && notBlank(eventResponse.data)) {
      setMetadataFileDiscovery(eventResponse.data);
    }
  }, [eventResponse.isSuccess, eventResponse.data]);

  const [contentProviders, setContentProviders] = useState([]);
  const allContentProviders = useContentProviders();
  useEffect(() => {
    if (allContentProviders.isSuccess && notBlank(allContentProviders.data)) {
      setContentProviders(allContentProviders.data);
    }
  }, [allContentProviders.isSuccess, allContentProviders.data]);

  const [contentProviderEndpoints, setContentProviderEndpoints] = useState([]);
  const allContentProviderEndpoints = useContentProviderEndpoints();
  useEffect(() => {
    if (
      allContentProviderEndpoints.isSuccess &&
      notBlank(allContentProviderEndpoints.data)
    ) {
      setContentProviderEndpoints(allContentProviderEndpoints.data);
    }
  }, [allContentProviderEndpoints.isSuccess, allContentProviderEndpoints.data]);

  return (
    <Container id="organization-view" classes={{ root: classes.root }}>
      {eventResponse.isLoading && (
        <Container style={{ height: 400 }}>
          <PanelLoadingIndicator />
        </Container>
      )}
      {eventResponse.isSuccess && notBlank(metadataFileDiscovery) && (
        <Fragment>
          <Header
            title="Metadata File Discovery Event Details"
            selectedActions={
              <Box>
                <Button
                  variant="text"
                  startIcon={<ArrowBackIcon />}
                  onClick={() =>
                    notBlank(state) && notBlank(state.previousLocation)
                      ? history.push(state.previousLocation)
                      : history.push(`/metadata-discovery-report`)
                  }
                >
                  {notBlank(state) && notBlank(state.label)
                    ? state.label
                    : "Back to Browse"}
                </Button>
              </Box>
            }
          />
          <Container classes={{ root: classes.panel }}>
            <Grid container spacing={2}>
              <Grid item sm={12}>
                <MeatadataFileDiscoveryEventCard
                  metadataFileDiscoveryEvent={metadataFileDiscovery}
                  contentProviderList={contentProviders}
                  contentProviderEndpointList={contentProviderEndpoints}
                />
              </Grid>

              <Grid item sm={12}>
                <MetadataFileDiscoveryErrorsCard jobId={jobId} />
              </Grid>

              <Grid item sm={12}>
                <MetadataFileDiscoveryMediaCard jobId={jobId} />
              </Grid>
            </Grid>
          </Container>
        </Fragment>
      )}
    </Container>
  );
};

export default MetadataFileDiscoveryDetailView;
